import { useSelector } from "react-redux";

import type { AgentState } from "../store/agentSlice";

/** Why sends cannot go now: the socket is reconnecting, or the server refused this tab. */
export type ConnectionDown = "reconnecting" | "unavailable" | null;

/**
 * The socket is waiting to (re)connect ("reconnecting": sends wait and go with the next open), or
 * the server refused this tab a ticket ("unavailable": nothing retries it). An attempt after an
 * open or a failed one counts too, so the notice does not blink between tries; a first connect in
 * flight does not.
 */
export function useConnectionDown(): ConnectionDown {
  return useSelector((state: { agent: AgentState }) => {
    const { status, everOpened, failedOnce } = state.agent.connection;
    if (status === "unavailable") return "unavailable";
    if (status === "backoff") return "reconnecting";
    return status === "connecting" && (everOpened || failedOnce) ? "reconnecting" : null;
  });
}
